
import {Component, Prop, Vue} from "vue-property-decorator";
import SimpleAppTable from "@/shared/AppTable/components/SimpleAppTable.vue";
import {IApp} from "@/interfaces/app.interface";
import ActionsCell from "@/modules/Report/Movements/components/tableCells/ActionsCell.vue";
import {isMobile} from "mobile-device-detect";
import {IMovementsReport} from "@/modules/Report/Movements/interfaces/movements-report.interface";
import {IAppTable} from "@/shared/AppTable/interfaces/sort-table-data";
import PayCell from "@/modules/Report/Movements/components/tableCells/PayCell.vue";

@Component({
  components: {
    PayCell,
    ActionsCell,
    SimpleAppTable,
  }
})
export default class CarCardMoveTable extends Vue {
  @Prop() tableData: IMovementsReport.ICarPopupTableItem[];
  @Prop() fromSelectMovePopup!: boolean;

  $refs: any;
  ActionsCell = ActionsCell;
  PayCell = PayCell;

  get dataProps(): IAppTable.ITableProp[] {
    let props = [
      { label: 'Въезд<br>Выезд',    prop: 'datePrint', },
      { label: 'Сто-<br>янка',      prop: 'hour', },
      { label: 'Сумма',             prop: 'tSumPrint',    propType: IApp.SortingPropType.Number, },
      {
        label: 'Оплата',
        prop: 'paySum',
        propType: IApp.SortingPropType.CustomComponent,
        customComponentName: 'PayCell',
        customComponentProps: { availableReturn: !this.fromSelectMovePopup, }
      },
      { label: 'Код<br>Корпорация', prop: 'corpPrint', },
      { label: 'Парковка',          prop: 'parkName', },
      { label: 'Комментарий',       prop: 'comment', },
      {
        label: 'Действия',
        prop: 'movId',
        propType: IApp.SortingPropType.CustomComponent,
        customComponentName: 'ActionsCell',
        customComponentProps: {
          fromCarPopup: true,
          fromSelectMovePopup: this.fromSelectMovePopup,
          tableList: this.tableList,
        },
      },
    ];

    return props;
  }

  get tableList(): IMovementsReport.ICarPopupTableItemPrint[] {
    const dateFormat = IApp.DateFormats.PrintedDateShort;
    const timeFormat = isMobile ? IApp.DateFormats.PrintedTime : IApp.DateFormats.TimeFull;

    let paySum = 0;
    this.tableData.forEach(item => paySum += item.paySum ? item.paySum : 0);
    paySum = this.$options.filters.currency(paySum, '₽');
    return this.tableData.map(item => {
        let dateBegPrint = item.dateBeg ? `${this.$options.filters.moment(item.dateBeg, dateFormat)} ${this.$options.filters.moment(item.dateBeg, timeFormat)}` : '';
        let dateEndPrint = item.finalScore ? 'ИТОГО' : item.dateEnd ? `${this.$options.filters.moment(item.dateEnd, dateFormat)} ${this.$options.filters.moment(item.dateEnd, timeFormat)}` : '';
        let datePrint = `${dateBegPrint}${dateBegPrint ? '<br>' : ''}${dateEndPrint}`;
        return {
          ...item,
          datePrint,
          dateBegPrint,
          dateEndPrint,
          corpPrint: `${item.movId ? item.movId : ''}<br>${item.corpName ? item.corpName : ' '}`,
          tSumPrint: item.tSum ? this.$options.filters.currency(item.tSum, '₽') : '',
          paySum: item.finalScore ? paySum : Boolean(item.paySum) ? item.paySum : 0,
          paySumPrint: item.finalScore ? paySum : item.paySum ? this.$options.filters.currency(item.paySum, '₽') : '',
        }
      })
      || [];
  }

  async openChangeDialog(index: number) {
    const actionComponent = this.$refs.SimpleAppTable.$refs.ActionsCell[index];
    if (actionComponent) {
      await actionComponent.openChangeDialog();
    }
  }
}
